import "./MorseFallRisk.scss";
import { Header } from "../Header/Header";
import SideBar from "../SideBar/Sidebar";
import redRating from "../../common/icons/svg/red-rating.svg";
import yellowRating from "../../common/icons/svg/yellow-rating.svg";
import greenRating from "../../common/icons/svg/green-rating.svg";
import React, { useState, useEffect } from 'react';

function MorseFallRisk(props) {
    const [historyOfFallingRating, setHistoryOfFallingRating] = useState(0);
    const [secondaryDiagRating, setSecondaryDiagRating] = useState(0);
    const [ambulatoryAidRating, setAmbulatoryAidRating] = useState(0);
    const [ivHeparinLockRating, setIvHeparinLockRating] = useState(0);
    const [gaitTraferringRating, setGaitTraferringRating] = useState(0);
    const [mentalStatusRating, setMentalStatusRating] = useState(0);
    const [totalScore, setTotalScore] = useState(0);

    const handleHistoryOfFallingRadio = (rating) => {
        setHistoryOfFallingRating(rating);
    }
    const handleSecondaryDiagRadio = (rating) => {
        setSecondaryDiagRating(rating);
    }
    const handleAmbulatoryAidRadio = (rating) => {
        setAmbulatoryAidRating(rating);
    }
    const handleGaitTraferringRadio = (rating) => {
        setGaitTraferringRating(rating);
    }
    const handleIvHeparinLockRadio = (rating) => {
        setIvHeparinLockRating(rating);
    }
    const handleMentalStatusRadio = (rating) => {
        setMentalStatusRating(rating);
    }
    useEffect(() => {
        setTotalScore(historyOfFallingRating +
            secondaryDiagRating +
            ambulatoryAidRating +
            ivHeparinLockRating +
            gaitTraferringRating +
            mentalStatusRating);

    }, [historyOfFallingRating,
        secondaryDiagRating,
        ambulatoryAidRating,
        ivHeparinLockRating,
        gaitTraferringRating,
        mentalStatusRating])

    return (
        <div className="fall-risk-score-container">
            <Header
            // handleWardChange={(item) => setSelectedWard(item)}
            // wardOption={wardOption}
            // selectedWard={selectedWard} 
            />
            <SideBar />
            <div className="fall-risk-score-body">
                <div className="score-top-header">
                    <div className="fall-risk-heading-container">
                        <span className="heading">Morse Fall Risk</span>
                        <div className={`show-score
                                        ${totalScore > 45 ? "red-score" : ""} 
                                        ${(totalScore <= 45) && (totalScore >= 25) ? "yellow-score" : ""}
                                        ${totalScore < 25 ? "green-score" : ""}
                                         `}>Score: {totalScore}</div>
                    </div>
                    <div className="fall-risk-rating-container">
                        <div className="common-rating-cls">
                            <img className="rating-color" src={redRating} />
                            <span>High Risk of Falling: &gt;45</span>
                        </div>
                        <div className="common-rating-cls">
                            <img className="rating-color" src={yellowRating} />
                            <span>Moderate Risk of Falling: 25-45</span>
                        </div>
                        <div className="common-rating-cls">
                            <img className="rating-color" src={greenRating} />
                            <span>Low Risk of Falling: &lt;25</span>
                        </div>
                    </div>
                </div>
                <div className="fall-risk-mcq-container">
                    <div className="common-mcq">
                        <div className="mcq-heading">History of falling; immediate or within 3 months</div>
                        <div className="mcq-score">{historyOfFallingRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="yes-falling" name="history-of-falling" onClick={() => handleHistoryOfFallingRadio(25)} />
                                <label htmlFor="yes-falling">Yes (+25)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="no-falling" name="history-of-falling" onClick={() => handleHistoryOfFallingRadio(0)} />
                                <label htmlFor="no-falling">No (+0)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading">Secondary diagnosis</div>
                        <div className="mcq-score">{secondaryDiagRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="yes-sec-diag" name="sec-diag-response" onClick={() => handleSecondaryDiagRadio(15)} />
                                <label htmlFor="yes-sec-diag">Yes (+15)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="no-sec-diag" name="sec-diag-response" onClick={() => handleSecondaryDiagRadio(0)} />
                                <label htmlFor="no-sec-diag">No (+0)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading">Ambulatory aid</div>
                        <div className="mcq-score">{ambulatoryAidRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="bed-rest" name="ambulator-aid" onClick={() => handleAmbulatoryAidRadio(0)} />
                                <label htmlFor="bed-rest">Bed rest/nurse assist (+0)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="crutches-cane" name="ambulator-aid" onClick={() => handleAmbulatoryAidRadio(15)} />
                                <label htmlFor="crutches-cane">Crutches/cane/walker (+15)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="furniture" name="ambulator-aid" onClick={() => handleAmbulatoryAidRadio(30)} />
                                <label htmlFor="furniture">Furniture (+30)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading">IV/Heparin Lock</div>
                        <div className="mcq-score">{ivHeparinLockRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="yes-iv-heparin-lock" name="iv-heparin" onClick={() => handleIvHeparinLockRadio(20)} />
                                <label htmlFor="yes-iv-heparin-lock">Yes (+20)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="no-iv-heparin-lock" name="iv-heparin" onClick={() => handleIvHeparinLockRadio(0)} />
                                <label htmlFor="no-iv-heparin-lock">No (+0)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading">Gait/Transferring</div>
                        <div className="mcq-score">{gaitTraferringRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="normal" name="gait-traferring" onClick={() => handleGaitTraferringRadio(0)} />
                                <label htmlFor="normal">Normal/bedrest/immobile (+0)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="weak" name="gait-traferring" onClick={() => handleGaitTraferringRadio(10)} />
                                <label htmlFor="weak">Weak (+10)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="impaired" name="gait-traferring" onClick={() => handleGaitTraferringRadio(20)} />
                                <label htmlFor="impaired">Impaired (+20)</label>
                            </div>
                        </div>
                    </div>
                    <div className="common-mcq">
                        <div className="mcq-heading">Mental status</div>
                        <div className="mcq-score">{mentalStatusRating}</div>
                        <div className="mcq-options-common">
                            <div className="radio-opt">
                                <input type="radio" id="own-ability" name="mental-status" onClick={() => handleMentalStatusRadio(0)} />
                                <label htmlFor="own-ability">Oriented to own ability (+0)</label>
                            </div>
                            <div className="radio-opt">
                                <input type="radio" id="forgets-limitations" name="mental-status" onClick={() => handleMentalStatusRadio(15)} />
                                <label htmlFor="forgets-limitations">Forgets limitations (+15)</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="fall-risk-total-rating-container">
                    <span>Total Fall Risk Score</span>
                    <div className="total-rating">{totalScore}</div>
                </div>
                <div className="submit-btn-container">
                    <div className="submit-btn" onClick={() => props.handleSubmitClick(totalScore)}>Submit</div>
                </div>


            </div>
        </div >
    )
}
export default MorseFallRisk;
